<template>
  <section class="ba-relative ba-flex-1 ba-bg-background-blocks ba-rounded-md">
    <vis-approval-queue-stage-header
      :stage="stage"
      :icon="stageIcon"
      :color-base="stateColorBase"
      :color-weak="stateColorWeak"
    />
    <div class="ba-px-4 ba-py-8">
      <vis-approval-queue-task
        v-for="(task, index) in stage.tasks"
        :key="index"
        :task="task"
        :queue-type="stage.queueType"
        :is-first="isFirstElem(index)"
        :is-last="isLastElem(index, stage.tasks)"
        :task-connection-line-color="stateColorBase"
        class="ba-mb-8 last:ba-mb-0"
      />
    </div>
    <vis-approval-queue-stage-connection-line
      v-if="!isLast"
      :color="stateColorBase"
    />
  </section>
</template>

<script>
import visApprovalQueueStageConnectionLine from "./vis-approval-queue-stage-connection-line";
import visApprovalQueueStageHeader from "./vis-approval-queue-stage-header";
import visApprovalQueueTask from "./vis-approval-queue-task";

export default {
  name: 'vis-approval-queue-stage',
  components: {
    visApprovalQueueStageConnectionLine,
    visApprovalQueueStageHeader,
    visApprovalQueueTask
  },
  props: {
    stage: {
      type: Object,
      default: () => ({})
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stateColorBase: null,
      stateColorWeak: null
    }
  },
  computed: {
    stageIcon() {
      return this.stage.queueType === 'параллельное' ?
        'parallel' :
        'consistently'
    }
  },
  created() {
    this.getStateColors(this.stage.state)
  },
  methods: {
    isFirstElem(i) {
      return i === 0;
    },
    isLastElem(i, el) {
      return i === el.length - 1;
    },
    getStateColors(val) {
      switch(val) {
        case "очередь не запущена":
          this.stateColorBase = "ba-text-text-blue-grey"
          this.stateColorWeak = "ba-text-white"
          break
        case "очередь находится на согласовании":
          this.stateColorBase = "ba-text-accent"
          this.stateColorWeak = "ba-text-primary-weak"
          break
        case "все задачи в очереди согласованы":
          this.stateColorBase = "ba-text-success-strong"
          this.stateColorWeak = "ba-text-success-weak"
          break
        case "хотя бы одна задача была отклонена":
          this.stateColorBase = "ba-text-error-weak-u"
          this.stateColorWeak = "ba-text-error-weak-d"
          break
      }
    }
  }
}
</script>
